
import React from "react";
import SEOHead from "@/components/SEOHead";
import { 
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQPage = () => {
  const faqItems = [
    {
      question: "O que é o Palpite Guru?",
      answer: "O Palpite Guru é um sistema especializado em gerar palpites para jogos de loteria utilizando algoritmos avançados e análise estatística para aumentar suas chances de ganhar."
    },
    {
      question: "Como funcionam as assinaturas?",
      answer: "Oferecemos três planos de assinatura: Básico, Premium e VIP. Cada plano oferece um número diferente de palpites diários e recursos adicionais. Você pode escolher entre pagamento mensal, trimestral ou anual, com descontos progressivos para períodos mais longos."
    },
    {
      question: "Posso cancelar minha assinatura a qualquer momento?",
      answer: "Sim, você pode cancelar sua assinatura a qualquer momento através da sua página 'Minha Conta'. O acesso aos recursos premium continuará disponível até o fim do período pago."
    },
    {
      question: "Como faço para atualizar meu plano?",
      answer: "Para atualizar seu plano, acesse a página 'Minha Conta' e clique em 'Gerenciar Assinatura'. Lá você poderá escolher um novo plano ou período de cobrança."
    },
    {
      question: "Os palpites realmente aumentam minhas chances de ganhar?",
      answer: "Nosso sistema utiliza algoritmos avançados para gerar palpites com base em análises estatísticas de resultados anteriores. Embora isso possa aumentar suas chances comparado a escolhas aleatórias, não podemos garantir vitórias, pois jogos de loteria são essencialmente jogos de sorte."
    },
    {
      question: "Qual a diferença entre os planos Básico, Premium e VIP?",
      answer: "O plano Básico oferece acesso a palpites limitados de Milhar e Centena. O plano Premium adiciona palpites de Grupo e aumenta o número total de palpites disponíveis. O plano VIP inclui todos os recursos, além de acesso ao software de análise avançada e suporte prioritário."
    },
    {
      question: "O que é o Software Turbinado?",
      answer: "O Software Turbinado é uma ferramenta avançada de análise disponível para assinantes VIP que permite visualizar padrões estatísticos, tendências históricas e realizar análises personalizadas para jogos de loteria."
    },
    {
      question: "Vocês oferecem garantia de reembolso?",
      answer: "Sim, oferecemos garantia de reembolso de 7 dias. Se você não estiver satisfeito com nossos serviços, entre em contato com nosso suporte dentro desse período para solicitar o reembolso."
    }
  ];

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <SEOHead
        title="Perguntas Frequentes - IA Palpite Guru"
        description="Tire suas dúvidas sobre o IA Palpite Guru. Como funciona, planos, assinaturas, métodos de pagamento, reembolso e muito mais."
        keywords="palpite guru dúvidas, como funciona palpite guru, planos palpite guru, perguntas frequentes bicho"
        canonical="/faq"
        jsonLd={faqJsonLd}
      />
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-center mb-8">Perguntas Frequentes</h1>
      
      <div className="max-w-3xl mx-auto bg-card rounded-xl p-6 shadow-sm">
        <Accordion type="single" collapsible className="w-full">
          {faqItems.map((item, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left font-medium">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        
        <div className="mt-8 bg-muted/30 p-4 rounded-lg text-center">
          <p className="mb-2">Não encontrou o que procura?</p>
          <a href="/suporte" className="text-primary hover:underline">
            Entre em contato com nosso suporte
          </a>
        </div>
      </div>
    </div>
    </>
  );
};

export default FAQPage;
